<template>
  <div>
    <div class="superuser-order-confirmation__top">
      <validation-observer
        ref="orderConfirmationSearchForm"
        tag="form"
        class="superuser-order-confirmation__form"
        @submit.prevent
        @keyup.enter="searchOrder()">
        <validation-provider v-slot="{errors}" rules="required" slim>
          <oie-base-input
            id="orderConfirmationOrderNumber"
            v-model="orderNumber"
            label-text="Ordernummer"
            placeholder="Ange ordernummer"
            :error-messages="errors"
            class="superuser-order-confirmation__input"></oie-base-input>
        </validation-provider>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/order' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          text="Sök order"
          @click="searchOrder()"></oie-base-button>
      </validation-observer>
    </div>

    <div v-if="notFound" class="superuser-gift-card__resend-failed">
      Ingen order hittades med angivet ordernummer.
    </div>

    <validation-observer
      v-if="orderPreview"
      ref="resendOrderConfirmationForm"
      tag="div"
      class="superuser-gift-card__tab-container">
      <div class="superuser-gift-card__block">
        <div class="superuser-order-confirmation__preview-row">
          <span class="superuser-order-confirmation__preview-label">Ordernummer</span>
          <span>{{ orderPreview.orderNumber }}</span>
        </div>
        <div class="superuser-order-confirmation__preview-row">
          <span class="superuser-order-confirmation__preview-label">Kund</span>
          <span>{{ orderPreview.customerName }}</span>
        </div>
        <div class="superuser-order-confirmation__preview-row">
          <span class="superuser-order-confirmation__preview-label">Skickas till e-post</span>
          <span>{{ orderPreview.email }}</span>
        </div>

        <oie-base-button
          class="button--with-border button--blue superuser-order-confirmation__resend-button"
          text="Skicka om orderbekräftelse"
          @click="resendOrderConfirmation()"></oie-base-button>

        <div v-if="resendResultMessage" :class="resendResult ? 'superuser-gift-card__resend-success' : 'superuser-gift-card__resend-failed'">
          {{ resendResultMessage }}
        </div>
      </div>

      <div class="superuser-gift-card__block superuser-gift-card__block--border">
        <h2 class="superuser-gift-card__block-header-history" @click="toggleHistory">
          Historik för omskickade orderbekräftelser
          <span class="arrow" :class="{'arrow-up': isHistoryExpanded, 'arrow-down': !isHistoryExpanded}"></span>
        </h2>

        <div v-if="isHistoryExpanded" class="superuser-resend-history">
          <div v-if="mq('medium')" class="superuser-resend-history__head">
            <div class="superuser-resend-history__cell">
              Datum
            </div>
            <div class="superuser-resend-history__cell">
              Skickat av
            </div>
            <div class="superuser-resend-history__cell">
              Skickat till
            </div>
          </div>

          <div
            v-for="(row) in resendHistory"
            :key="'hist' + row.startDate"
            class="superuser-resend-history__body-row">
            <div class="superuser-resend-history__cell">
              {{ row.startDate }}
            </div>
            <div class="superuser-resend-history__cell">
              {{ row.user }}
            </div>
            <div class="superuser-resend-history__cell">
              {{ row.sentToRecipientEmail }}
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    orderNumber: null,
    orderPreview: null,
    notFound: false,
    resendResult: null,
    resendResultMessage: null,
    resendHistory: null,
    isHistoryExpanded: false
  }),
  methods: {
    async searchOrder() {
      const isValid = await this.$refs.orderConfirmationSearchForm.validate()

      if (!isValid) {
        return
      }

      this.orderPreview = null
      this.notFound = false
      this.resendResult = null
      this.resendResultMessage = null
      this.resendHistory = null
      this.isHistoryExpanded = false

      httpService.get(this.createEndpoint('confirmation')).then(({ data }) => {
        if (data.success) {
          this.orderPreview = data
        } else {
          this.notFound = true
        }
      }).catch(() => {
        this.notFound = true
      })
    },
    resendOrderConfirmation() {
      httpService.post(this.createEndpoint('confirmation/resend')).then(({ data }) => {
        this.resendResult = data.success
        this.resendResultMessage = data.message
      })
    },
    toggleHistory() {
      this.isHistoryExpanded = !this.isHistoryExpanded
      if (this.isHistoryExpanded) {
        httpService.get(this.createEndpoint('confirmation/resend/history')).then(({ data }) => {
          this.resendHistory = data.history
        })
      }
    },
    createEndpoint(action) {
      return `superuser/order/${this.orderNumber}/${action}`
    }
  }
}
</script>

<style lang="scss">
.superuser-order-confirmation__top {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(full);

  @include media(medium) {
    flex-direction: row;
  }
}

.superuser-order-confirmation__form {
  display: flex;
  flex-direction: column;
  width: 100%;
  order: 1;

  @include media(small) {
    flex-direction: row;
    max-width: 30rem;
  }

  @include media(medium) {
    order: initial;
  }
}

.superuser-order-confirmation__input {
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-bottom: 0;
    margin-right: measure(half);
  }
}

.superuser-order-confirmation__preview-row {
  display: flex;
  margin-bottom: measure(quarter);
}

.superuser-order-confirmation__preview-label {
  font-weight: bold;
  min-width: 12rem;
}

.superuser-order-confirmation__resend-button {
  display: inline-block;
  margin-top: measure(half);
  margin-bottom: measure(half);
}
</style>
